import { Component, DestroyRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ZapierIntegrationDialogComponent } from '../zapier-integration-dialog/zapier-integration-dialog.component';
import { CAL_ICON, CALL_BACK_ICON, GHL_ICON,MAKE_ICON ,GOOGLE_ICON, NOTIFICATION_ICON, SMS_ICON, TELEGRAM_ICON, ZAPIER_ICON } from '../../../../app.component';
import { AiAgentResponse } from '../../../../models/responses/ai-agent-response';
import { CalIntegrationDialogComponent } from '../cal-integration-dialog/cal-integration-dialog.component';
import { AiConfigurationPageEventsService } from '../../../../events/ai-configuration-page-events.service';
import { SubscriptionHelper } from '../../../../classes/subscription-helper';
import { TelegramIntegrationComponent } from '../telegram-integration/telegram-integration.component';
import { environment } from '../../../../environments/environments';
import { NotificationIntegrationComponent } from '../notification-integration/notification-integration.component';
import { SmsSettingDialogComponent } from '../sms-setting-dialog/sms-setting-dialog.component';
import { CallBackSettingDialogComponent } from '../call-back-setting-dialog/call-back-setting-dialog.component';
import { GoogleSheetDialogComponent } from '../google-sheet-dialog/google-sheet-dialog.component';
import { MakeIntegrationDialogComponent } from '../make-integration-dialog/make-integration-dialog.component';

export interface Integration {
  name: string;
  callBack: Function;
  icon: string;
}

@Component({
  selector: 'app-integration-adder-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatDivider,
    MatButtonModule,
    NgFor,
    MatIconModule,
    NgIf,
    NgClass,
    ZapierIntegrationDialogComponent,
    MakeIntegrationDialogComponent,
    CalIntegrationDialogComponent
  ],
  templateUrl: './integration-adder-dialog.component.html',
  styleUrl: './integration-adder-dialog.component.scss'
})
export class IntegrationAdderDialogComponent {
  subscriptions: SubscriptionHelper;
  integrations: Integration[] = [];

  constructor(
    public dialogRef: MatDialogRef<IntegrationAdderDialogComponent>,
    public dialog: MatDialog,
    private aiConfigurationPageEventsService: AiConfigurationPageEventsService,
    @Inject(MAT_DIALOG_DATA) public data: AiAgentResponse,
    private destroyRef: DestroyRef
  ) {
    this.subscriptions = new SubscriptionHelper(destroyRef);
  }

  ngOnInit() {
    this.initIntegrations();
    this.initSubscriptions();
  }

  initIntegrations() {
    this.integrations.push({ name: 'Zapier', callBack: () => this.onOpenZapierIntegrationDialog(), icon: ZAPIER_ICON });
    this.integrations.push({ name: 'Make', callBack: () => this.onOpenMakeIntegrationDialog(), icon: MAKE_ICON })
    this.integrations.push({ name: 'Telegram', callBack: () => this.onOpenTelegramIntegrationDialog(), icon: TELEGRAM_ICON });
    this.integrations.push({ name: 'Notification', callBack: () => this.onOpenNotificationIntegrationDialog(), icon: NOTIFICATION_ICON });
    this.integrations.push({ name: 'Cal', callBack: () => this.onOpenCalIntegrationDialog(), icon: CAL_ICON });
    this.integrations.push({ name: 'GHL', callBack: () => this.onOpenGHLIntegrationDialog(), icon: GHL_ICON });
    if (!this.data.smsSettings) {
      this.integrations.push({ name: 'SMS', callBack: () => this.onOpenSmsSettingsDialog(), icon: SMS_ICON });
    }
    if (!this.data.callBackSettings) {
      this.integrations.push({ name: 'Call Back', callBack: () => this.onOpenCallBackSettingsDialog(), icon: CALL_BACK_ICON });
    }
    // if(!this.data.integrations.googleSheetsIntegraton){
    //   this.integrations.push({name:'Google Sheet',callBack:()=>this.onOpenGoogleSheetsDialog(),icon:GOOGLE_ICON})
    // }
  }

  initSubscriptions() {
    this.subscribeToOnDialogCloseEvent();
    this.subscribeToOnZapierDialogCloseEvent();
    this.subscribeToOnSmsSettingsDialogCloseEvent();
    this.subscribeToOnMakeDialogCloseEvent();
  }

  subscribeToOnDialogCloseEvent() {
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onCalIntegrationAddedEvent.subscribe(() => {
        this.dialogRef.close();
      }));
  }

  subscribeToOnZapierDialogCloseEvent() {
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onZappierIntegrationAddedEvent.subscribe(() => {
        this.dialogRef.close();
      }));
  }

  subscribeToOnMakeDialogCloseEvent() {
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onMakeIntegrationAddedEvent.subscribe(() => {
        this.dialogRef.close();
      }));
  }

  subscribeToOnSmsSettingsDialogCloseEvent() {
    this.subscriptions.add(
      this.aiConfigurationPageEventsService.onSmsSettingsAddedEvent.subscribe(() => {
        this.dialogRef.close();
      }));
  }

  onOpenZapierIntegrationDialog() {
    this.dialog.open(ZapierIntegrationDialogComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.data }
    });
  }

  onOpenMakeIntegrationDialog() {
    this.dialog.open(MakeIntegrationDialogComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.data }
    });
  }

  onOpenTelegramIntegrationDialog() {
    this.dialog.open(TelegramIntegrationComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.data }
    });
  }

  onOpenCalIntegrationDialog() {
    this.dialog.open(CalIntegrationDialogComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.data }
    });
  }

  onOpenNotificationIntegrationDialog() {
    this.dialog.open(NotificationIntegrationComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.data }
    });
  }

  onOpenSmsSettingsDialog() {
    this.dialog.open(SmsSettingDialogComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.data, smsSettings: undefined }
    });
  }

  onOpenCallBackSettingsDialog() {
    this.dialog.open(CallBackSettingDialogComponent, {
      width: '50%',
      autoFocus: false,
      data: { aiAgent: this.data, callBackSetting: undefined }
    });
  }
  onOpenGoogleSheetsDialog(){
    window.open(`${environment.baseUrl}/auth/google-sheets/${this.data.id}`, "_self");
  }


  onOpenGHLIntegrationDialog() {
    window.open(`${environment.baseUrl}/auth/lead-connector/${this.data.id}`, "_self");
  }
}
